<template>
  <div class="password-strength">
    <label
      class="password-strength__label"
      for="password"
    >
      {{ $t('login.new-password') }}
    </label>
    <password-eye
      id="password"
      v-model="passwordText"
      type="password"
      maxlength="20"
      @input="calculateStrength"
    />
    <strength-bar :value="strength" />
  </div>
</template>

<script>
import PasswordStrengthCalculator from '@/services/passwordStrengthCalculator';
import PasswordEye from '@/components/inputs/PasswordEye';
import StrengthBar from './StrengthBar';

export default {
  components: {
    StrengthBar,
    PasswordEye,
  },
  data: () => ({
    passwordText: '',
    max: 100,
    strength: 0,
  }),
  methods: {
    calculateStrength() {
      this.strength = PasswordStrengthCalculator.calculateStrength(this.passwordText);
      this.$emit('change', this.passwordText, this.strength);
    },
  },
};
</script>
